import { machineCatalogActions } from "../../constants/actionTypes";

const getCatalogListData = (data) => ({
  type: machineCatalogActions.FETCH_CATALOG_LIST_DATA,
  payload: data,
});

const setCatalogListData = (data) => ({
  type: machineCatalogActions.SET_CATALOG_LIST_DATA,
  payload: data,
});

const setCatalogListError = (data) => ({
  type: machineCatalogActions.SET_CATALOG_LIST_ERROR,
  payload: data,
});

const deleteCatalogRequest = (data) => ({
  type: machineCatalogActions.DELETE_CATALOG,
  payload: data,
});

const deleteCatalogSuccess = (data) => ({
  type: machineCatalogActions.DELETE_CATALOG_SUCCESS,
  payload: data,
});

const deleteCatalogError = (data) => ({
  type: machineCatalogActions.DELETE_CATALOG_ERROR,
  payload: data,
});

const changeCatalogStatus = (data) => ({
  type: machineCatalogActions.CHANGE_CATALOG_STATUS,
  payload: data,
});

const changeCatalogStatusLoading = (data) => ({
  type: machineCatalogActions.CHANGE_CATALOG_STATUS_LOADING,
  payload: data,
});

const changeCatalogStatusSuccess = (data) => ({
  type: machineCatalogActions.CHANGE_CATALOG_STATUS_SUCCESS,
  payload: data,
});

const changeCatalogStatusError = (data) => ({
  type: machineCatalogActions.CHANGE_CATALOG_STATUS_ERROR,
  payload: data,
});

const createCloneRequest = (data) => ({
  type: machineCatalogActions.CLONE_REQUEST,
  payload: data,
});

const createCloneSuccess = (data) => ({
  type: machineCatalogActions.CLONE_SUCCESS,
  payload: data,
});

const createCloneError = (data) => ({
  type: machineCatalogActions.CLONE_ERROR,
  payload: data,
});

const cloneRequest = (data) => ({
  type: machineCatalogActions.SET_CLONE_REQUEST,
  payload: data,
});

const cloneSuccess = (data) => ({
  type: machineCatalogActions.SET_CLONE_SUCCESS,
  payload: data,
});

const cloneError = (data) => ({
  type: machineCatalogActions.SET_CLONE_ERROR,
  payload: data,
});

const resetCloneError = (data) => ({
  type: machineCatalogActions.RESET_CLONE_ERROR,
  payload: data,
});
const resetDeleteError = (data) => ({
  type: machineCatalogActions.RESET_DELETE_ERROR,
  payload: data,
});

const resetCatalogList = (data) => ({
  type: machineCatalogActions.RESET_CATALOG_LIST,
  payload: data,
});

const requestCatalogExport = (data) => ({
  type: machineCatalogActions.REQUEST_EXPORT_CATALOG,
  payload: data,
});

const successCatalogExport = (data) => ({
  type: machineCatalogActions.SUCCESS_EXPORT_CATALOG,
  payload: data,
});

const errorCatalogExport = (data) => ({
  type: machineCatalogActions.ERROR_EXPORT_CATALOG,
  payload: data,
});

const createCatalogPlanMapping = (data) => ({
  type: machineCatalogActions.REQUEST_CREATE_CATALOG_PLAN_MAP,
  payload: data,
});

const successCatalogPlanMapping = (data) => ({
  type: machineCatalogActions.SUCCESS_CREATE_CATALOG_PLAN_MAP,
  payload: data,
});

const errorCatalogPlanMapping = (data) => ({
  type: machineCatalogActions.ERROR_CREATE_CATALOG_PLAN_MAP,
  payload: data,
});

const requestUpdateCatalogPlanMap = (id, data) => ({
  type: machineCatalogActions.REQUEST_UPDATE_CATALOG_PLAN_MAP,
  id,
  payload: data,
});

const successUpdateCatalogPlanMap = (data) => ({
  type: machineCatalogActions.SUCCESS_UPDATE_CATALOG_PLAN_MAP,
  payload: data,
});

const errorUpdateCatalogPlanMap = (data) => ({
  type: machineCatalogActions.ERROR_UPDATE_CATALOG_PLAN_MAP,
  payload: data,
});

const requestRetriveCatalogPlanMap = (data) => ({
  type: machineCatalogActions.REQUEST_RETRIVE_CATALOG_PLAN_MAP,
  payload: data,
});

const successRetriveCatalogPlanMap = (data) => ({
  type: machineCatalogActions.SUCCESS_RETRIVE_CATALOG_PLAN_MAP,
  payload: data,
});

const errorRetriveCatalogPlanMap = (data) => ({
  type: machineCatalogActions.ERROR_RETRIVE_CATALOG_PLAN_MAP,
  payload: data,
});

const requestMarkCatalogB2c = (id, data) => ({
  type: machineCatalogActions.REQUEST_MARKED_CATALOG_B2C,
  id,
  payload: data,
});

const successMarkCatalogB2c = (data) => ({
  type: machineCatalogActions.SUCCESS_MARKED_CATALOG_B2C,
  payload: data,
});

const errorMarkCatalogB2c = (data) => ({
  type: machineCatalogActions.ERROR_MARKED_CATALOG_B2C,
  payload: data,
});

const publicCloudFilterAction = (data) => ({
  type: machineCatalogActions.SET_PUBLIC_CLOUD_ACTION,
  payload: data,
});

export {
  getCatalogListData,
  setCatalogListData,
  setCatalogListError,
  deleteCatalogRequest,
  deleteCatalogSuccess,
  deleteCatalogError,
  changeCatalogStatus,
  changeCatalogStatusSuccess,
  changeCatalogStatusError,
  createCloneRequest,
  createCloneSuccess,
  createCloneError,
  cloneRequest,
  cloneSuccess,
  cloneError,
  resetCloneError,
  resetCatalogList,
  resetDeleteError,
  requestCatalogExport,
  successCatalogExport,
  errorCatalogExport,
  createCatalogPlanMapping,
  successCatalogPlanMapping,
  errorCatalogPlanMapping,
  requestUpdateCatalogPlanMap,
  successUpdateCatalogPlanMap,
  errorUpdateCatalogPlanMap,
  requestRetriveCatalogPlanMap,
  successRetriveCatalogPlanMap,
  errorRetriveCatalogPlanMap,
  requestMarkCatalogB2c,
  successMarkCatalogB2c,
  errorMarkCatalogB2c,
  changeCatalogStatusLoading,
  publicCloudFilterAction
};
